import { render } from "./SignOut.vue?vue&type=template&id=ba8f8e7e"
import script from "./SignOut.vue?vue&type=script&lang=js"
export * from "./SignOut.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__